import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor ads search params
 */
export default class AdsSearchParamsValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Array} deps.bodyTypes
   * @param {Number} deps.fuelType
   * @param {Number} deps.kmsMax
   * @param {Number} deps.kmsMin
   * @param {Number} deps.model
   * @param {Number} deps.brand
   * @param {Number} deps.priceMax
   * @param {Number} deps.province
   * @param {Number} deps.yearMax
   * @param {Number} deps.yearMin
   * @param {String} deps.keywords
   */
  constructor({
    bodyTypes,
    fuelType,
    kmsMax,
    kmsMin,
    model,
    brand,
    priceMax,
    province,
    yearMax,
    yearMin,
    keywords,
    version
  } = {}) {
    super({
      bodyTypes,
      fuelType,
      kmsMax,
      kmsMin,
      model,
      brand,
      priceMax,
      province,
      yearMax,
      yearMin,
      keywords,
      version
    })

    /**
     * @type {Array}
     */
    this._bodyTypes = bodyTypes

    /**
     * @type {Number}
     */
    this._fuelType = fuelType

    /**
     * @type {Number}
     */
    this._kmsMax = kmsMax

    /**
     * @type {Number}
     */
    this._kmsMin = kmsMin

    /**
     * @type {Number}
     */
    this._model = model

    /**
     * @type {Number}
     */
    this._brand = brand

    /**
     * @type {Number}
     */
    this._priceMax = priceMax

    /**
     * @type {Number}
     */
    this._province = province

    /**
     * @type {Number}
     */
    this._yearMax = yearMax

    /**
     * @type {Number}
     */
    this._yearMin = yearMin

    /**
     * @type {String}
     */
    this._keywords = keywords

    /**
     * @type {String}
     */
    this._version = version
  }

  /**
   * @return {Object}
   */
  toJSON() {
    return {
      bodyTypes: this._bodyTypes,
      fuelType: this._fuelType,
      kmsMax: this._kmsMax,
      kmsMin: this._kmsMin,
      model: this._model,
      brand: this._brand,
      priceMax: this._priceMax,
      province: this._province,
      yearMax: this._yearMax,
      yearMin: this._yearMin,
      keywords: this._keywords,
      version: this._version
    }
  }
}
